import React from 'react';
import { useTheme } from '../../context/ThemeContext';

// Ambient atmospheric background with soft blurred blobs
// Gives sections depth without being distracting
// Palette: golf greens, warm golds, deep navy - no pink
const AmbientBackground = ({ variant = 'green' }) => {
  const { isDarkMode } = useTheme();

  const palettes = {
    green: {
      light: ['rgba(16, 185, 129, 0.15)', 'rgba(5, 150, 105, 0.12)', 'rgba(251, 191, 36, 0.08)'],
      dark: ['rgba(16, 185, 129, 0.08)', 'rgba(5, 150, 105, 0.06)', 'rgba(251, 191, 36, 0.04)']
    },
    gold: {
      light: ['rgba(251, 191, 36, 0.15)', 'rgba(245, 158, 11, 0.1)', 'rgba(16, 185, 129, 0.08)'],
      dark: ['rgba(251, 191, 36, 0.08)', 'rgba(245, 158, 11, 0.05)', 'rgba(16, 185, 129, 0.04)']
    },
    navy: {
      light: ['rgba(30, 58, 138, 0.12)', 'rgba(16, 185, 129, 0.1)', 'rgba(251, 191, 36, 0.08)'],
      dark: ['rgba(30, 58, 138, 0.15)', 'rgba(16, 185, 129, 0.06)', 'rgba(251, 191, 36, 0.04)']
    }
  };

  const colors = palettes[variant][isDarkMode ? 'dark' : 'light'];

  return (
    <div className="absolute inset-0 overflow-hidden pointer-events-none">
      {/* Blob 1 - top left */}
      <div
        className="absolute -top-32 -left-32 w-[500px] h-[500px] rounded-full blur-3xl"
        style={{ background: colors[0] }}
      />
      {/* Blob 2 - bottom right */}
      <div
        className="absolute -bottom-32 -right-32 w-[600px] h-[600px] rounded-full blur-3xl"
        style={{ background: colors[1] }}
      />
      {/* Blob 3 - center accent */}
      <div
        className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[400px] h-[400px] rounded-full blur-3xl"
        style={{ background: colors[2] }}
      />
    </div>
  );
};

export default AmbientBackground;